<template>
  <div class="content">
    <h1>Контакты приемной комиссии</h1>

    <div>
      <div class="form">
        <div class="form__group">
          <html-editor v-model="localContent" />
        </div>

        <div class="form__actions">
          <button type="button" class="btn btn--outline" :disabled="!hasChanges" @click="resetToOriginal">
            Сбросить
          </button>
          <button type="button" class="btn btn--primary" :disabled="!hasChanges" @click="saveContacts">
            Сохранить
          </button>
          <div v-if="formattedUpdatedDate">
            Контакты сохранены {{ formattedUpdatedDate }}
          </div>
        </div>
      </div>
      <div class="preview-section">
        <h3>Предпросмотр:</h3>
        <div class="preview-content" v-html="previewContent"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watchEffect } from 'vue'
import { useContactsStore } from '../model/useContacts'
import HtmlEditor from './HtmlEditor.vue'

const contactStore = useContactsStore()

const localContent = ref('')

const previewContent = computed(() => localContent.value || '<p class="text-muted">Контент не загружен</p>')
const hasChanges = computed(() => localContent.value != contactStore.content)
const formattedUpdatedDate = computed(() => {
  return new Date(contactStore.lastUpdated * 1000).toLocaleString('ru-RU') || ''
})

const resetToOriginal = () => {
  if (confirm('Отменить изменения?')) localContent.value = contactStore.content
}

const saveContacts = () => contactStore.updateContacts(localContent.value)

watchEffect(() => localContent.value = contactStore.content || '')
onMounted(() => contactStore.getContacts())
</script>